import React from 'react';
import ResetPassword from '../../components/auth/ResetPassword/ResetPassword';
import './ResetPasswordPage.css';

const ResetPasswordPage = () => {
  return (
    <div className="reset-password-page">
      <ResetPassword />
    </div>
  );
};

export default ResetPasswordPage;

